import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StateEffects } from './store/state.effects';

@NgModule({
    declarations: [],
    imports: [EffectsModule.forFeature([StateEffects])],
})
export class StateModule {}
